import { Rule, Stage } from '../app/models/rule.model';

export function isActivationConditionStale(rule: Rule | null | undefined): boolean {
  if (!rule?.lastActivationConditionTrueDateTime || !rule?.periodInMinutes) return false;
  const thresholdMs = rule.periodInMinutes * 2 * 60 * 1000;
  return (Date.now() - new Date(rule.lastActivationConditionTrueDateTime).getTime()) > thresholdMs;
}

export function isRuleStale(rule: Rule | null | undefined): boolean {
  if (!rule?.lastEvaluationDateTime || !rule?.periodInMinutes) return false;
  const thresholdMs = rule.periodInMinutes * 2 * 60 * 1000;
  return (Date.now() - new Date(rule.lastEvaluationDateTime).getTime()) > thresholdMs;
}
